/*! Bead Yours - pattern sheet for making an order. Reads a design code from the URL (#p1... or #j1...)
    or from a paste box. Needs by-palette.js, by-core.js, by-jewelry.js. Mount: <div data-by-pattern>. */
(function (g) {
  'use strict';
  var BY = g.BeadYours = g.BeadYours || {};
  var h = BY.h;
  var SYMS = 'ABCDEFGHJKLMNPQRSTUVWXYZabdefghijkmnpqrstuvwxyz23456789';

  function perlerSheet(root, d) {
    var counts = BY.perlerCounts(d.grid), sym = {}, total = 0;
    counts.forEach(function (c, i) { sym[c.color.id] = SYMS[i % SYMS.length]; total += c.count; });
    var boardsX = Math.ceil(d.w / 29), boardsY = Math.ceil(d.h / 29);
    root.appendChild(h('div', { class: 'by-muted' }, [
      h('b', { text: d.w + ' x ' + d.h + ' beads' }), ' - about ' + BY.fmtInches(d.w) + ' x ' + BY.fmtInches(d.h) + ' - ' + total + ' beads - ' + counts.length + ' colors - ' +
      (boardsX * boardsY) + ' large board' + (boardsX * boardsY > 1 ? 's (' + boardsX + ' x ' + boardsY + ')' : '')
    ]));
    var legend = h('div', { class: 'by-legend' });
    counts.forEach(function (c) {
      var i = h('i', { text: sym[c.color.id], style: { background: c.color.hex, color: c.color.light ? '#222' : '#fff' } });
      legend.appendChild(h('div', {}, [i, h('span', {}, [h('b', { text: c.count + ' ' }), c.color.name + ' ', h('small', { class: 'by-muted', text: c.color.code })])]));
    });
    // big grid
    var cell = d.w > 58 ? 14 : d.w > 29 ? 18 : 24, m = 26;
    var cv = h('canvas'); cv.width = d.w * cell + m * 2; cv.height = d.h * cell + m * 2;
    var ctx = cv.getContext('2d');
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, cv.width, cv.height);
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    for (var y = 0; y < d.h; y++) for (var x = 0; x < d.w; x++) {
      var id = d.grid[y * d.w + x], px = m + x * cell, py = m + y * cell;
      if (!id) continue;
      var c = BY.perlerById(id);
      ctx.fillStyle = c.hex; ctx.fillRect(px, py, cell, cell);
      ctx.fillStyle = c.light ? 'rgba(0,0,0,.75)' : 'rgba(255,255,255,.9)';
      ctx.font = '700 ' + Math.round(cell * 0.5) + 'px Arial, sans-serif';
      ctx.fillText(sym[id], px + cell / 2, py + cell / 2 + 1);
    }
    for (var gx = 0; gx <= d.w; gx++) {
      ctx.strokeStyle = gx % 29 === 0 ? '#c93f79' : gx % 5 === 0 ? 'rgba(0,0,0,.45)' : 'rgba(0,0,0,.12)';
      ctx.lineWidth = gx % 29 === 0 ? 2 : 1;
      ctx.beginPath(); ctx.moveTo(m + gx * cell + .5, m); ctx.lineTo(m + gx * cell + .5, m + d.h * cell); ctx.stroke();
    }
    for (var gy = 0; gy <= d.h; gy++) {
      ctx.strokeStyle = gy % 29 === 0 ? '#c93f79' : gy % 5 === 0 ? 'rgba(0,0,0,.45)' : 'rgba(0,0,0,.12)';
      ctx.lineWidth = gy % 29 === 0 ? 2 : 1;
      ctx.beginPath(); ctx.moveTo(m, m + gy * cell + .5); ctx.lineTo(m + d.w * cell, m + gy * cell + .5); ctx.stroke();
    }
    ctx.fillStyle = '#6c6380'; ctx.font = '600 11px Arial, sans-serif';
    for (var nx = 5; nx <= d.w; nx += 5) { ctx.fillText(String(nx), m + (nx - 0.5) * cell, m / 2); ctx.fillText(String(nx), m + (nx - 0.5) * cell, m + d.h * cell + m / 2); }
    for (var ny = 5; ny <= d.h; ny += 5) { ctx.fillText(String(ny), m / 2, m + (ny - 0.5) * cell); ctx.fillText(String(ny), m + d.w * cell + m / 2, m + (ny - 0.5) * cell); }
    var prev = h('img', { alt: 'Finished look', src: BY.perlerThumb(d.w, d.h, d.grid, 240, { mode: 'beads', full: true }), style: { width: '160px', height: 'auto', borderRadius: '10px', background: '#f6f3fa' } });
    root.appendChild(h('div', { style: { display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap', marginTop: '10px' } }, [prev, legend]));
    root.appendChild(cv);
    root.appendChild(h('p', { class: 'by-muted by-small', text: 'Pink lines = edges of 29 x 29 boards. Bold lines every 5 pegs. Iron on medium with paper, both sides, until beads fuse; cool under a book to keep it flat.' }));
  }

  function jewelrySheet(root, d) {
    var piece = (BY.JEWELRY_PIECES || []).filter(function (p) { return p.key === d.p; })[0];
    var size = piece ? piece.sizes.filter(function (s) { return s[0] === d.s; })[0] : null;
    var beads = d.b || [], counts = {}, mm = 0, li = 0;
    beads.forEach(function (b) { var n = BY.jewelryBeadName(b); counts[n] = (counts[n] || 0) + 1; mm += BY.jewelryBeadMM(b); });
    root.appendChild(h('div', { class: 'by-muted' }, [h('b', { text: (piece ? piece.name : d.p) + ' - ' + (size ? size[1] : d.s) }),
      ' - ' + beads.length + ' beads - strung length about ' + (mm / 25.4).toFixed(1) + '"' + (d.p === 'earrings' ? ' per earring (make 2)' : '')]));
    var wrap = h('div', { style: { maxWidth: '520px' } }); wrap.innerHTML = BY.jewelryPreview(d); root.appendChild(wrap);
    var seq = h('div', { class: 'by-seq' });
    beads.forEach(function (b, i) {
      var cell = h('span', { title: BY.jewelryBeadName(b) });
      cell.innerHTML = BY.beadSVG(b, 34, b[0] === 'l' ? li++ : 0);
      cell.appendChild(document.createTextNode(String(i + 1)));
      seq.appendChild(cell);
    });
    root.appendChild(h('h3', { text: 'String in this order (left to right)' }));
    root.appendChild(seq);
    var legend = h('div', { class: 'by-legend' });
    Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; }).forEach(function (k) { legend.appendChild(h('div', {}, [h('b', { text: String(counts[k]) }), ' ' + k])); });
    root.appendChild(h('h3', { text: 'Bead list' }));
    root.appendChild(legend);
  }

  function mount(el) {
    if (el.__byPattern) return; el.__byPattern = true;
    el.classList.add('by-app', 'by-pattern');
    var out = h('div');
    var ta = h('textarea', { class: 'by-input', rows: '2', placeholder: 'Paste a design code (starts with p1. or j1.)', 'aria-label': 'Design code', style: { textTransform: 'none' } });
    var bar = h('div', { class: 'by-noprint' }, [ta, h('div', { class: 'by-row' }, [
      h('button', { class: 'by-btn by-btn--primary', type: 'button', text: 'Show pattern', onclick: function () { show(ta.value); } }),
      h('button', { class: 'by-btn', type: 'button', text: 'Print', onclick: function () { g.print(); } }),
      h('button', { class: 'by-btn', type: 'button', text: 'Open in builder', onclick: function () {
        var code = (ta.value || '').trim(); if (!code) return;
        var url = (code.indexOf('j1.') === 0 ? (el.getAttribute('data-jewelry-url') || '/pages/jewelry-builder') : (el.getAttribute('data-perler-url') || '/pages/perler-builder')) + '#design=' + encodeURIComponent(code);
        g.location.href = url;
      } })
    ])]);
    el.appendChild(bar); el.appendChild(out);
    function show(code) {
      code = String(code || '').trim(); out.innerHTML = '';
      if (!code) return;
      ta.value = code;
      try {
        if (code.indexOf('p1.') === 0) perlerSheet(out, BY.decodePerler(code));
        else if (code.indexOf('j1.') === 0) jewelrySheet(out, BY.decodeJewelry(code));
        else throw new Error('Unknown code');
      } catch (e) { out.appendChild(h('p', { class: 'by-muted', text: 'That design code could not be read. Copy the whole _pattern or _design value from the order.' })); }
    }
    var hash = decodeURIComponent((g.location.hash || '').replace(/^#/, '').replace(/^design=/, ''));
    if (hash) show(hash);
    g.addEventListener('hashchange', function () { show(decodeURIComponent(g.location.hash.replace(/^#/, '').replace(/^design=/, ''))); });
  }
  function boot() { document.querySelectorAll('[data-by-pattern]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})(window);
